import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { ISubscriptionPlan } from 'app/shared/model/subscription-plan.model';
import { getEntities as getSubscriptionPlans } from 'app/entities/subscription-plan/subscription-plan.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { IStatuses } from 'app/shared/model/statuses.model';
import { getEntities as getStatuses } from 'app/entities/statuses/statuses.reducer';
import { getEntity, updateEntity, createEntity, reset } from './subscription-history.reducer';
import { ISubscriptionHistory } from 'app/shared/model/subscription-history.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface ISubscriptionHistoryUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const SubscriptionHistoryUpdate = (props: ISubscriptionHistoryUpdateProps) => {
  const [subscriptionPlanId, setSubscriptionPlanId] = useState('0');
  const [userId, setUserId] = useState('0');
  const [statusesId, setStatusesId] = useState('0');
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { subscriptionHistoryEntity, subscriptionPlans, users, statuses, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/subscription-history');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }

    props.getSubscriptionPlans();
    props.getUsers();
    props.getStatuses();
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...subscriptionHistoryEntity,
        ...values,
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="satshrutApp.subscriptionHistory.home.createOrEditLabel">Create or edit a SubscriptionHistory</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : subscriptionHistoryEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="subscription-history-id">ID</Label>
                  <AvInput id="subscription-history-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="startDateLabel" for="subscription-history-startDate">
                  Start Date
                </Label>
                <AvField id="subscription-history-startDate" type="date" className="form-control" name="startDate" />
              </AvGroup>
              <AvGroup>
                <Label id="endDateLabel" for="subscription-history-endDate">
                  End Date
                </Label>
                <AvField id="subscription-history-endDate" type="date" className="form-control" name="endDate" />
              </AvGroup>
              <AvGroup>
                <Label id="transactionIdLabel" for="subscription-history-transactionId">
                  Transaction Id
                </Label>
                <AvField id="subscription-history-transactionId" type="text" name="transactionId" />
              </AvGroup>
              <AvGroup>
                <Label id="transactionDateLabel" for="subscription-history-transactionDate">
                  Transaction Date
                </Label>
                <AvField id="subscription-history-transactionDate" type="date" className="form-control" name="transactionDate" />
              </AvGroup>
              <AvGroup>
                <Label for="subscription-history-subscriptionPlan">Subscription Plan</Label>
                <AvInput id="subscription-history-subscriptionPlan" type="select" className="form-control" name="subscriptionPlan.id">
                  <option value="" key="0" />
                  {subscriptionPlans
                    ? subscriptionPlans.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.id}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
              <AvGroup>
                <Label for="subscription-history-user">User</Label>
                <AvInput id="subscription-history-user" type="select" className="form-control" name="user.id">
                  <option value="" key="0" />
                  {users
                    ? users.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.login}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
              <AvGroup>
                <Label for="subscription-history-statuses">Statuses</Label>
                <AvInput id="subscription-history-statuses" type="select" className="form-control" name="statuses.id">
                  <option value="" key="0" />
                  {statuses
                    ? statuses.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.id}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/subscription-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  subscriptionPlans: storeState.subscriptionPlan.entities,
  users: storeState.userManagement.users,
  statuses: storeState.statuses.entities,
  subscriptionHistoryEntity: storeState.subscriptionHistory.entity,
  loading: storeState.subscriptionHistory.loading,
  updating: storeState.subscriptionHistory.updating,
  updateSuccess: storeState.subscriptionHistory.updateSuccess,
});

const mapDispatchToProps = {
  getSubscriptionPlans,
  getUsers,
  getStatuses,
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionHistoryUpdate);
